/*
 * @Author: mayqiyue
 * @Date: 2019-03-06 14:15:29
 * @Last Modified by: mayqiyue
 * @Last Modified time: 2019-03-06 18:30:48
 */

import store from "@/store";
import * as types from "@/store/constants/types";
import { isNumber } from "@/utils/lodash";

/**
 *
 * @param price 传入美元价格,带不带货币符号都可以，返回值中一定回到货币符号 eg：$4.99
 * @return 本地化后的价格
 */

export const localizedPrice = (price: string | number) => {
  if (localizedPriceText(price).indexOf("undefined") > -1) {
    return price
  } else {
    return localizedPriceText(price)
  }
};

export const localizedPriceText = (price: string | number) => {
  let priceString: string;
  if (isNumber(price)) {
    priceString = price.toString();
  } else {
    priceString = price as string;
  }
  const localizedMap = localizedPriceMap();
  if (!localizedMap) {
    return "$" + parseFloat(parsePrice(priceString));
  }

  const priceValue = parseFloat(parsePrice(priceString));

  let find: any;
  Object.keys(localizedMap).forEach(key => {
    const element = localizedMap[key];
    if (element.price === priceValue) {
      find = element.localSymbol + element.priceString;
    }
  });
  if (find) {
    return find;
  }

  let delta: any = 100000;
  let rawOffer: any;
  const iapOffers = allIapOffers();
  // tslint:disable-next-line:prefer-for-of
  for (let index = 0; index < iapOffers.length; index++) {
    const element = iapOffers[index];
    const currentDelta = Math.abs(parseFloat(parsePrice(element.iap.price)) - priceValue);
    if (currentDelta < delta) {
      delta = currentDelta;
      rawOffer = element;
    }
  }
  // Not found the same offer, so need to caculate ourselves
  let localiedItem: any;
  Object.keys(localizedMap).forEach(key => {
    const element = localizedMap[key];
    if (key === rawOffer.iap.product_id) {
      localiedItem = element;
    }
  });

  if (!rawOffer || !localiedItem) {
    return priceString;
  }

  if (localiedItem.localSymbol === "$") {
    return "$" + priceValue;
  }

  const rawPrice = parseFloat(parsePrice(rawOffer.iap.price));
  const r = (localiedItem.price + 0.01) / (rawPrice + 0.01);
  const numString = (Math.floor(priceValue * r * 100) / 100).toString();
  return localiedItem.localSymbol + transformResult(numString);
};

/**
 *
 * @param offer The offer need to be localized
 * @return  {localCode: "CNY", localSymbol: "¥", price:18, priceString:"18.00"}
 */
export const localizedOffer = (offer: any) => {
  // const array = localizedPriceArray();
  // if (!array) {
  //   return { localCode: "$", localSymbol: "$", price: offer.iap.price, priceString: "" };
  // }
  // const newOffer = [...offer];
  // return newOffer;
};

const localizedPriceMap = () => {
  const settings = store.state.settingModule;
  if (settings && settings.localizePrice) {
    return settings.localizePrice;
  }
  return null;
};

const allIapOffers = () => {
  const offers: any[] = [];
  const kinds = ["follow_offers", "golden_follow_offers", "like_offers", "view_offers", "comment_offers"];
  kinds.forEach((kind: string) => {
    const array: [any] = store.getters[types.GETTER_SETTING_DATA][kind];
    if (array && array.length > 0) {
      array.filter((item: any) => item.iap).forEach((item: any) => offers.push(item));
    }
  });
  return offers;
};

const parsePrice = (string: string) => {
  const value = string.match(/\d+(?:\.\d+)?/g);
  if (value) {
    return value[0];
  }
  return "";
};

// 个位数从最5，6，8，9这4个数字中，找最接近的一个来替换。
// 小数点统一.99
// 如：153.34，3替换为5，小数点改成.99，最后变为 155.99
export const transformResult = (num: any) => {
  try {
      if (!num) {
          return '';
      }
      if (typeof num !== 'string') {
          num = num.toString()
      }
      // 将小数拆分成整数位和小数位
      const numArr = num.split('.');
      const validNumList: any = [5, 6, 8, 9];
      const integer = numArr[0];
      const everyNumArr = integer.split("");
      const units = everyNumArr[everyNumArr.length - 1];
      let resultUnits: any = Number(units);
      resultUnits = judgeExist(resultUnits, validNumList);
      return integer.substring(0, integer.length - 1) + resultUnits + '.99';
  } catch (e) {
      return '';
  }

};

const judgeExist: any = (num: number, arr: any) => {
  if (arr.indexOf(num) === -1) {
    num++;
    return judgeExist(num, arr);
  } else {
    return num;
  }
};
